// extracted by mini-css-extract-plugin
module.exports = {"macOsInfo":"styles_macOsInfo__6sd2_","item":"styles_item__mbLQr","icon":"styles_icon__CfCTp","globalInfo":"styles_globalInfo__FTQds"};